import { createSelector } from 'reselect';
import { identity, get } from 'lodash/fp';

const blockSelectionsSelector = createSelector(
  get(['blockSelections', 'blocks']),
  identity,
);

export default blockSelectionsSelector;
